<template>
    <div> 
 
        <div class="progress-bar-container">   
            <div class="progress" :style="'width:'+ formatPercent(percentComplete) + '; left:' + (percentComplete>0? '0%':'-1%')"></div>
            <div class="progress-bar-border"></div> 
            <a v-for="(item,index) in lessonContext.segmentProgress" :key="index"  
            :class="index==(lessonContext.segmentProgress.length-1)? '' : 'section'" 
            :style="'width:' + formatPercent(item.navigator.duration()/lessonContext.duration)" :title="getName(item,index)">
            
                <transition name="fade" > 
                    <div v-if="replayIndex>=0">
                        <div  v-if="index<=lessonContext.segmentIndex  && replaySegments[index] && index<=replayNavigatorIndex"  
                            class="replay-segment"  :style="`width:${percentStringAtIndex(index)}`"  >
                            <div class="d-flex" v-if="replayNavigatorIndex==index" >                                
                                <div class="replay-segment-active"   :style="`width:${activeSegmentPosition}`" ></div>
                                <div class="navigator-caret-bar"></div>
                                <div class="navigator-caret-box">
                                    <icon class="navigator-caret" :name="'caret-down-fill'" /> 
                                </div>
                            </div>
                            <div class="replay-segment-fill" v-else></div>
                        </div>
                    </div>                    
                </transition>
                <!-- :style="getReplayStyle(index)" -->
            </a> 
        </div>
    </div>
</template>
<script lang="ts">
import { Options, Prop, Vue as VueBase, Watch } from 'vue-property-decorator';  
import {LessonContext, LessonController, } from '@/controllers/LessonController'; 
import Popover from '@/components/core/Popover.vue';
import { ReplayItem, ReplaySegment } from './CardData';
import Icon from '../core/Icon.vue';

@Options({components:{Popover, Icon}})
export default class LessonProgressBar extends VueBase {
   
   @Prop()
   public lessonController!: LessonController;

   @Prop()
   public replayItems!: ReplayItem[];

   @Prop()
   public replaySegments!: ReplaySegment[];

   @Prop({default:-1})
   public replayIndex!: number;

   public percentComplete = 0.0;
   private eventsAttached = false;

   public percentStringAtIndex(index: number): string
   {
     let percentString="100%";
     if (this.lessonContext.segmentIndex==index)
     {
        let item = this.lessonContext.segmentProgress[index];
        percentString = this.formatPercent(item.navigator.navigatorPercentComplete());
     }

     return percentString;
   }

 
  
   public get activeSegmentPosition()
   {
        const adjustedIndex = this.adjustedIndex();
 
        if (adjustedIndex>0 && this.replaySegment)
        {
            const count = this.replaySegment.replayItems.length;
            return this.formatPercent(adjustedIndex/count);            
        }

        return "0%"
   }

   public get currentReplayItem(): ReplayItem | null
   {
      if (this.replayIndex>=0)
      {
        return this.replayItems[this.replayIndex];
      }  

      return null;
   }

   public get replaySegment(): ReplaySegment | null
   {
      let ni = this.replayNavigatorIndex;
      if (ni>=0)
      {
        return this.replaySegments[ni];
      }

      return null;
   }



   public get replayNavigatorIndex(): number
   {
       let navigatorIndex=-1;

       if (this.replayIndex>=0)
       {
           navigatorIndex=this.replayItems[this.replayIndex].navigatorIndex;
       }

       return navigatorIndex;
   }



   public adjustedIndex()
   {
      //15 replay cards, 5 are in the last segment.
      //you go back 2.  What percentage complete are we?
      
      //known: 
      // replayIndex 12
      // 5 cards in current segment 3/5 
      // 10 other cards
      // (replayIndex - otherCards) + 1 / 
      //replayItems.length - replayIndex 
            
      let replaySegment = this.replaySegment;
      let adjustedIndex = 0;

      if (replaySegment)
      {
        const segmentStart = replaySegment.startIndex;
        adjustedIndex = this.replayIndex-segmentStart;
       }
 
      return adjustedIndex;
   }

   public getReplayStyle(index: number)
   {
       if (this.replayIndex>=0)
       {
           let navigatorIndex=this.replayItems[this.replayIndex].navigatorIndex;
           let replaySegment= this.replaySegments[navigatorIndex];
       }
       else
       {
        return "";
       }

   }

   public get lessonContext(): LessonContext {
    return this.lessonController.lessonContext;
   }

   @Watch("controller")
   private attachEvents()
   {
     if (!this.eventsAttached && this.lessonController)
     {
        this.lessonController.events.on("lessonProgress",()=>{
            
            this.percentComplete =  this.lessonContext.percentComplete;
        });

        this.eventsAttached=true;
     }
   }

   public mounted()
   {
    this.attachEvents();
   }
 
    public formatPercent(value: number): string {
        const percentString = `${(value * 100)}%`;
        return percentString;
    }
 
    public getName(item: any,index = 0)
    {
      let name = item.navigator.getSegment().name;
      if (!name) name= "#"+index;

      return name;
    }

}
</script>
 
